// extracted by mini-css-extract-plugin
module.exports = {"bulletList":"_785ad1f0","numberedList":"_506efe4b"};